export default __webpack_public_path__ + "static/media/posts.61f50462.jpeg";